export default __webpack_public_path__ + "static/media/233-transnistria.3fe69d9d.svg";